import CodeError from './CodeError';

class InvalidSerialNumberError extends CodeError {
  constructor() {
    const code = 'invalidSerialNumber';
    const message = 'Invalid serial number';
    super(code, message);
    if ('function' === typeof Error.captureStackTrace) {
      Error.captureStackTrace(this, this.constructor);
    } else {
      this.stack = (new Error(message)).stack;
    }
  }
}

export default InvalidSerialNumberError;
